module.exports = __webpack_public_path__ + "img/jingpai.a54d473c.png";